import Bugsnag from '@bugsnag/js';

export default function logError(exception) {
  if (Bugsnag) {
    Bugsnag.notify(exception);
  }
  // eslint-disable-next-line no-console
  console.error(exception);
}
